import {isAnalytixLive} from '../../../utils/premise';

export const getHeaderClassName = (): string => {
  if (isAnalytixLive()) {
    return 'header bp4-dark';
  }
  return 'header';
}
